import { Controller } from "@hotwired/stimulus"

// Keeps the SERVER-RENDERED review surfaces in step with comments made in the
// browser: the Review Activity panel, the Finish Review modal's contents, and the
// canvas marker avatars.
//
// The floating composer posts its comment and announces it with a window event.
// Every surface that has to react to it is rendered by Rails and sits in a
// different frame, so rather than rebuilding any of them in JS this controller
// re-asks the builder for them and applies the turbo stream it gets back — the
// same mechanism `course-builder#refresh` uses for the menu/content/settings
// frames, which do not contain these three.
//
// Mounted on the builder root because two of the three targets are replaced by
// the very stream it applies; a listener inside one of them would be torn out
// mid-flight. There are no Stimulus outlets in this project, which is why the
// composer reports itself through window events rather than calling in directly.
export default class extends Controller {
  static values = { url: String }

  // Applying the stream is the whole job. The canvas repaints off the markers
  // element's own connect() rather than off this method returning, because Turbo
  // renders the stream asynchronously — see course-review-markers.
  async refresh() {
    if (!this.hasUrlValue) return

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "text/vnd.turbo-stream.html" },
        credentials: "same-origin"
      })
      if (!response.ok) return

      window.Turbo.renderStreamMessage(await response.text())
    } catch (_error) {
      // A failed refresh leaves the last good render on screen rather than a
      // half-updated one; the next comment retries.
    }
  }
}
